module.exports = __webpack_public_path__ + "img/page8.68d1bd28.jpg";